export const TitlePart = (props) => {
  const { label } = props;
  return (
    <div className="flex flex-column w-full mb-4">
      <div className="font-bold text-2xl mb-4 mx-1">{label}</div>
      <div className="grid gap-2 w-full pl-3">{props.children}</div>
    </div>
  );
};
